import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllUsers = async () => {
  try {
    const resp = await apiClient.get(`/invoiceRoleManagement/getAllNonVendorUsers`, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
